

































import { Component, Prop, Watch, Vue, SaitenExtender } from "saiten-base";
import { DmApi, DmShareds, CurrentUserState } from "division-marker";

@Component({ components: {}, mixins: [] })
export default class DmRegistrationEmail extends Vue {
  error: null | string = null;
  condition = { email_adress: "", email_adress2: "" };

  get current_user_state(): CurrentUserState {
    return this.$store.state.current_user;
  }
  get current_user() {
    return this.current_user_state.user;
  }

  async exec() {
    this.error = null;
    let con = this.condition;
    if (con.email_adress == "")
      this.error = "登録するメールアドレスを入力してください。";
    else if (con.email_adress != con.email_adress2)
      this.error = "登録するメールアドレス(確認)が間違っています。";
    else this.exec_registration_email();
  }
  async exec_registration_email() {
    let data = await DmApi.registration_email(this.condition);
    if (data.result == "ok") {
      alert("メールアドレス登録が完了しました。");
      location.reload();
    } else {
      alert(data.message);
    }
  }

  async delete_email(email: string) {
    if (confirm(email + "を削除します。よろしいですか？")){
      const res = await DmShareds.Http.post("./api/dm/auth/delete_email", {email: email});
      let data = res.data;
      if(data.result == "ok"){
        alert("メールアドレス削除が完了しました。");
        location.reload();
      }else{
        alert(data.message);
      }
    }
  }
}
